import { Amplify } from 'aws-amplify'

export const configureAmplify = async () => {
  const host = window.location.host

  /* eslint-disable no-multi-spaces */
  const hosts = [
    { host: 'qa2-diagnostics.tranehome.com',    domain: 'tr-dev.net'     },
    { host: 'qa-diagnostics.tranehome.com',     domain: 'tr-qa.net'      },
    { host: 'stage1-diagnostics.tranehome.com', domain: 'tr-staging.net' },
    { host: 'diagnostics.tranehome.com',        domain: 'tranehome.net'  },
    { host: 'diagnostics.tranetechdev.com',     domain: 'tr-qa.net'      },
    { host: 'localhost',                        domain: 'tr-qa.net'      }
  ]
  /* eslint-enable no-multi-spaces */

  let domain = hosts.find(h => h.host === host)?.domain

  if (!domain) {
    domain = host.split('.').slice(-2).join('.')
  }

  return fetch(`https://metadata.${domain}/amplify-config-trane.json`)
    .then(async (response) => await response.json())
    .then((config) => {
      Amplify.configure({
        ...config,
        API: {
          ...config.API,
          REST: {
            ...config.API?.REST,
            deviceLookupApi: {
              name: 'deviceLookupApi',
              endpoint: `https://device-lookup-api.${domain}`
            }
          }
        }
      })
    })
}
